__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "pflm-b2gnew";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "18.2.14", () => (__webpack_require__.e(7172).then(() => (() => (__webpack_require__(4791))))));
			register("@angular/cdk", "18.2.14", () => (__webpack_require__.e(9017).then(() => (() => (__webpack_require__(1398))))));
			register("@angular/common/http", "18.2.14", () => (__webpack_require__.e(6443).then(() => (() => (__webpack_require__(6443))))));
			register("@angular/common", "18.2.14", () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))));
			register("@angular/core", "18.2.14", () => (__webpack_require__.e(7404).then(() => (() => (__webpack_require__(7404))))));
			register("@angular/forms", "18.2.14", () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(4456))))));
			register("@angular/platform-browser", "18.2.14", () => (__webpack_require__.e(436).then(() => (() => (__webpack_require__(436))))));
			register("@angular/router", "18.2.14", () => (__webpack_require__.e(7696).then(() => (() => (__webpack_require__(7696))))));
			register("@ng-select/ng-select", "13.9.1", () => (__webpack_require__.e(2223).then(() => (() => (__webpack_require__(2223))))));
			register("@ngneat/helipopper", "9.2.1", () => (__webpack_require__.e(1152).then(() => (() => (__webpack_require__(1152))))));
			register("@ngx-translate/core", "15.0.0", () => (__webpack_require__.e(852).then(() => (() => (__webpack_require__(852))))));
			register("@ngx-translate/http-loader", "8.0.0", () => (__webpack_require__.e(8952).then(() => (() => (__webpack_require__(8952))))));
			register("@ngxs/store", "18.1.6", () => (__webpack_require__.e(5110).then(() => (() => (__webpack_require__(5110))))));
			register("@pflm-shared", "0.2.327", () => (__webpack_require__.e(7081).then(() => (() => (__webpack_require__(7081))))));
			register("@tanstack/react-query-persist-client", "5.85.3", () => (__webpack_require__.e(4873).then(() => (() => (__webpack_require__(4873))))));
			register("@tanstack/react-query", "5.85.3", () => (__webpack_require__.e(3728).then(() => (() => (__webpack_require__(3728))))));
			register("markdown-to-text", "0.1.1", () => (__webpack_require__.e(6383).then(() => (() => (__webpack_require__(6383))))));
			register("mobx-react-lite", "4.1.0", () => (__webpack_require__.e(3162).then(() => (() => (__webpack_require__(3162))))));
			register("mobx", "6.13.7", () => (__webpack_require__.e(9745).then(() => (() => (__webpack_require__(9745))))));
			register("react-dom", "19.1.1", () => (__webpack_require__.e(7866).then(() => (() => (__webpack_require__(5485))))));
			register("react-router-dom", "7.8.1", () => (__webpack_require__.e(5546).then(() => (() => (__webpack_require__(5546))))));
			register("react", "19.1.1", () => (__webpack_require__.e(920).then(() => (() => (__webpack_require__(920))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};